import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import type { TFunction } from 'i18next';

import {
  EmailStatus,
  EmailStatusObj,
} from '../../../common/pokCore/validation/enums';

export const EmailStatusIcon = (props: {
  status?: EmailStatus;
  t: TFunction<'applicationLng', 'applicationLng'>;
}) => {
  let icon;
  if (!props.status) {
    return <></>;
  }
  const statusTxt = props.t(EmailStatusObj[props.status]);
  if (props.status === EmailStatus.Sent) {
    icon = <Icon.Envelope className="icon-green mt-2" size={18} />;
  } else {
    icon = <Icon.EnvelopeExclamationFill className="icon-red mt-2" size={18} />;
  }
  return (
    <div className="text-center align-middle">
      <OverlayTrigger
        overlay={<Tooltip style={{ position: 'fixed' }}>{statusTxt}</Tooltip>}
      >
        {icon}
      </OverlayTrigger>
    </div>
  );
};
